import { cx } from '@emotion/css';

import { Link } from 'apps/shared/scripts/components';

import { lightClassName, logoClassName, textClassName } from './styles';

interface Props {
  light?: boolean;
}

const Logo = ({ light }: Props) => {
  return (
    <Link className={cx(logoClassName, { [lightClassName]: light })} to={'/'}>
      <span className={textClassName}>cardjoy</span>
    </Link>
  );
};

Logo.displayName = 'Logo';

export default Logo;
